require("./number");


// WEBPACK FOOTER //
// ./src/prototype/index.js